var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-menu fl-right",style:({ left: _vm.left, top: _vm.top }),on:{"click":_vm.goToIndex}},[_c('div',{staticClass:"wrap",style:({ background: _vm.$store.state.themeInfo.themeColor })},[_c('van-icon',{attrs:{"name":"wap-home-o"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }